export const HelpCenterLink = 'https://pimmy.procuro.com';
export const CreateATicketLink = 'https://support.wendys.procuro.com/createticket';

export const DefaultCultures = [
  { culture: 'en-US', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/US.png' },
  { culture: 'fr-CA', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/FR.png' },
  { culture: 'es-US', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/ES.png' },
  { culture: 'ro-RO', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/RO.png' },
  { culture: 'ru-RU', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/RU.png' },
  { culture: 'ka-GE', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/GE.png' },
  { culture: 'hy-AM', imageUrl: 'https://sms-cdn.b-cdn.net/assets-web/wendys/AM.png' },
];
